import React, { Fragment, useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import {
    Badge,
    Button, Card, CardBody, DropdownMenu, DropdownToggle, Input, DropdownItem, Modal,
    ModalBody, ModalFooter, ModalHeader, Row, UncontrolledDropdown
} from "reactstrap";
import { Colxx } from "../../../../../components/common/CustomBootstrap";
import { AxiosAPI, getGroupID, getUserID } from "../../../../../helpers/AxiosAPI";
import { connect } from 'react-redux';
import { API_Logs } from "../../../../../constants/APIs";
import moment from "moment";
import Pagination from "../../../../../containers/pages/Pagination";

function Logs({ logType, visible, label, toggle, propertyId, locale }) {
    const [logList, setLogList] = useState([]);
    const [pageSizes, setpageSizes] = useState([10, 15, 20, 25]);
    const [currentPage, setcurrentPage] = useState(1);
    const [SelectedPageSize, setSelectedPageSize] = useState(10);
    const startIndex = (currentPage - 1) * SelectedPageSize;
    const endIndex = currentPage * SelectedPageSize;
    const [TotalItems, setTotalItems] = useState(0);
    const [TotalPages, setTotalPages] = useState(1);

    const changePageSize = (size) => {
        setSelectedPageSize(size);
        setcurrentPage(1);
    };

    useEffect(() => {
        AxiosAPI({
            method: 'get',
            url: `${API_Logs}?groupId=${getGroupID()}&propertyId=${propertyId}&type=${logType}&pageNumber=${currentPage}&pageSize=${SelectedPageSize}`,
        }).then((res) => {
            setTotalItems(res.data.totalItems);
            setTotalPages(res.data.totalPages);
            setLogList(res.data.logs);
        });
    }, [getUserID(), currentPage, SelectedPageSize]);

    const onChangePage = (page) => {
        setcurrentPage(page);
    };



    return (
        <Fragment>
            <Modal isOpen={visible} toggle={toggle} style={{ maxWidth: '1000px' }} backdrop="static">
                <ModalHeader toggle={toggle}>
                    {label}
                </ModalHeader>
                <ModalBody className="pb-0">
                    <Row>
                        <Card className="mx-3 w-100">
                            <Colxx xxs="12" className="px-4">
                                {(logList !== undefined && logList.length > 0) && logList.map((m, index) =>
                                    <Row className="my-4">
                                        <Colxx xxs="12" xs="3" className="p-4 mt-1">
                                            <Fragment>
                                                <b>Version On:</b><br />
                                                {moment(m.date).format(
                                                    'MMM DD, YYYY h:mm a'
                                                )}<br /><br />
                                                {m.action !== undefined &&
                                                    <Fragment>
                                                        <b>Action:</b><br />
                                                        <span style={{ color: `${m.action.includes('Delete') ? 'red' : 'green'}` }} >{m.action}</span>
                                                    </Fragment>
                                                }
                                            </Fragment>
                                        </Colxx>
                                        <Colxx xxs="12" xs="9">
                                            <Card className="d-flex" key={`faqItem_${index}`} style={{ borderRadius: '15px' }}>
                                                <CardBody className="mx-2">
                                                    <Row className="mb-1">
                                                        <Colxx xxs="12" className='mb-1'>
                                                            <b>Question:</b>
                                                        </Colxx>
                                                        <Colxx xxs="12" className="ml-0 mb-1">
                                                            {m.content.Question}
                                                        </Colxx>
                                                    </Row>
                                                    <Row className="mb-1">
                                                        <Colxx xxs="12" className='mb-1'>
                                                            <b>Answer:</b>
                                                        </Colxx>
                                                        <Colxx xxs="12" dangerouslySetInnerHTML={{ __html: m.content.Answer.replace(/((?:<li>[\s\S]*?<\/li>\s*)+)/g, '<ul style="margin:0;padding-left:20px;">$1</ul>') }} />
                                                    </Row>
                                                    {(m.content.Status !== undefined && m.content.Status !== null && m.content.Status !== "") && <Row className="mb-1">
                                                        <Colxx xxs="12" className='mb-1'>
                                                            <b>Status: </b>
                                                            <span className={m.content.Status === 'Archive' ? 'text-danger' : 'text-success'}>{m.content.Status}</span>
                                                        </Colxx>
                                                    </Row>}
                                                    {(m.content.Collection !== undefined && m.content.Collection !== null && m.content.Collection.length > 0) && <Row className="mb-1">
                                                        <Colxx xxs="12" className='mb-1'>
                                                            <b>Collection: </b>
                                                            <span>{m.content.Collection[0]}</span>
                                                        </Colxx>
                                                    </Row>}
                                                    {(m.comments !== undefined && m.comments !== null && m.comments !== '') &&
                                                        <Row>
                                                            <Colxx xxs="12" className='mb-1'>
                                                                <b>Comments:</b>
                                                                {m.comments}
                                                            </Colxx>
                                                        </Row>}
                                                </CardBody>
                                            </Card>
                                        </Colxx>
                                    </Row>
                                )}
                            </Colxx>
                        </Card>
                        <Colxx xxs="12">
                            <div className="float-md-right my-3">
                                <span className="text-muted text-small mr-1">{`${startIndex}-${endIndex} of ${TotalItems} `}</span>
                                <UncontrolledDropdown className="d-inline-block">
                                    <DropdownToggle caret color="outline-dark" size="xs">
                                        {SelectedPageSize}
                                    </DropdownToggle>
                                    <DropdownMenu right>
                                        {pageSizes.map((size, index) => {
                                            return (
                                                <DropdownItem
                                                    key={index}
                                                    onClick={() => changePageSize(size)}
                                                >
                                                    {size}
                                                </DropdownItem>
                                            );
                                        })}
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                            </div>
                        </Colxx>
                    </Row>
                </ModalBody>
                <ModalFooter className="w-100 d-flex justify-content-center pt-0 pb-3">
                    <Pagination
                        currentPage={currentPage}
                        totalPage={TotalPages}
                        onChangePage={(i) => onChangePage(i)}
                    />
                    <Button className="ml-0 mr-5 mt-2" color='secondary' size="xs" onClick={toggle}>Back</Button>
                </ModalFooter>
            </Modal>
        </Fragment >
    )
}
const mapStateToProps = ({ settings }) => {
    const { propertyId, locale } = settings;
    return {
        propertyId,
        locale,
    };
};

export default injectIntl(connect(mapStateToProps, {})(Logs));